package br.gov.go.pge.permanenciaweb.site.components

import androidx.compose.runtime.Composable
import br.gov.go.pge.permanenciaweb.site.IndustrialPalette
import com.varabyte.kobweb.compose.css.PointerEvents
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.pointerEvents
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.ComponentKind
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.addVariantBase
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

sealed interface ToastKind : ComponentKind

val ToastStyle = CssStyle<ToastKind> {
    base {
        Modifier
            .position(Position.Fixed)
            .bottom(1.cssRem)
            .right(1.cssRem)
            .backgroundColor(IndustrialPalette.Ink)
            .color(IndustrialPalette.White)
            .padding(0.625.cssRem, 1.cssRem)
            .borderRadius(0.25.cssRem)
            .opacity(0)
            .transition(Transition.of("opacity", 200.ms))
            .pointerEvents(PointerEvents.None)
    }
}

val ToastVisibleVariant = ToastStyle.addVariantBase {
    Modifier.opacity(1)
}

/** Error feedback (e.g. "pessoa já adicionada"): same toast, red background. */
val ToastDangerVariant = ToastStyle.addVariantBase {
    Modifier.backgroundColor(IndustrialPalette.Red)
}

/** Visible + danger: a variant can't compose another one, so the pair is spelled out. */
val ToastDangerVisibleVariant = ToastStyle.addVariantBase {
    Modifier.backgroundColor(IndustrialPalette.Red).opacity(1)
}

/** Fixed bottom-right toast; fades over 0.2s and never captures pointer events. */
@Composable
fun Toast(message: String, visible: Boolean, danger: Boolean = false) {
    val variant = when {
        danger && visible -> ToastDangerVisibleVariant
        danger -> ToastDangerVariant
        visible -> ToastVisibleVariant
        else -> null
    }
    Div(
        attrs = ToastStyle.toModifier(variant)
            .then(Modifier.id("toast"))
            .toAttrs(),
    ) {
        Text(message)
    }
}
